import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { useContext, useMemo } from 'react';
import memoizeOne from 'memoize-one';
import { ReactReduxContext, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { defaultGetId, getKeyOf } from "./helpers";
import { __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_RISK_BECOMING_MAINTAINER } from "./internal";
var injectCurrents = __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_RISK_BECOMING_MAINTAINER.injectCurrents,
  selectCurrents = __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_RISK_BECOMING_MAINTAINER.selectCurrents,
  monkeyPatchStore = __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_RISK_BECOMING_MAINTAINER.monkeyPatchStore;
export var generateCurrentKey = function generateCurrentKey() {
  return Symbol('redux-current generated key');
};
export function composeCurrentKeySelector(key, options) {
  return function (state) {
    return selectCurrents(state, options)[key];
  };
}

// An injector should be memoized for provider lifetime
var useLocalInjector = function useLocalInjector() {
  return React.useMemo(function () {
    return memoizeOne(injectCurrents);
  }, []);
};
var _CurrentProvider = function _CurrentProvider(_ref) {
  var children = _ref.children,
    name = _ref.name,
    value = _ref.value,
    bulk = _ref.bulk;
  var context = useContext(ReactReduxContext);
  var contextInjector = useLocalInjector();
  var values = React.useMemo(function () {
    return name && typeof value !== 'undefined' ? _objectSpread(_objectSpread({}, bulk), {}, _defineProperty({}, getKeyOf(name), value)) : bulk;
  }, [name, value, bulk]);
  var nextContext = React.useMemo(function () {
    return _objectSpread(_objectSpread({}, context), {}, {
      store: monkeyPatchStore(contextInjector, context.store, values)
    });
  }, [context, contextInjector, values]);
  return /*#__PURE__*/React.createElement(ReactReduxContext.Provider, {
    value: nextContext
  }, children);
};

// TODO-1: tests for changing selector to raw value and back
// TODO-2: convert to selectors if input is selector
// const selectDataDict = createSelector(selectDataList, convertListToObjectBy(selectId));
// const selectDataById = createSelector(
//   selectDataDict,
//   (_, { id }) => id,
//   (dict, id) => dict[id],
// );
// const selectIds = createSelector(selectDataList, (list) => list.map(selectId));

function useItemsById(listOrSelector, getId) {
  var selector = useMemo(function () {
    return createSelector(function (state) {
      return typeof listOrSelector === 'function' ? listOrSelector(state) : listOrSelector;
    }, function (list) {
      return list.map(function (item, index) {
        return [getId(item, index), item];
      });
    });
  }, [listOrSelector, getId]);
  return useSelector(selector);
}
var CurrentMapper = function CurrentMapper(_ref2) {
  var _getId;
  var children = _ref2.children,
    name = _ref2.name,
    value = _ref2.value,
    bulk = _ref2.bulk;
  var list = useItemsById(value !== null && value !== void 0 ? value : bulk === null || bulk === void 0 ? void 0 : bulk[getKeyOf(name)], (_getId = name.getId) !== null && _getId !== void 0 ? _getId : defaultGetId);
  return list.map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      id = _ref4[0],
      item = _ref4[1];
    return /*#__PURE__*/React.createElement(CurrentProvider, {
      bulk: bulk,
      key: id,
      name: name,
      value: item,
      "data-t-id": "redux-current-src"
    }, children);
  });
};
export var CurrentProvider = Object.assign(_CurrentProvider, {
  Mapper: CurrentMapper
});